import styled from 'styled-components'

import { mediaPrintRemoveMargPaddBackg, tableCss } from '../../styles'

const WrapTableDiv = styled.div`
  ${mediaPrintRemoveMargPaddBackg}
  ${tableCss}
`

export { WrapTableDiv }
